module.exports = __webpack_public_path__ + "static/media/download.e64d8f07.svg";